import { render, staticRenderFns } from "./InitialControl.vue?vue&type=template&id=2e2ee870&scoped=true&"
import script from "./InitialControl.vue?vue&type=script&lang=js&"
export * from "./InitialControl.vue?vue&type=script&lang=js&"
import style0 from "./InitialControl.vue?vue&type=style&index=0&id=2e2ee870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ee870",
  null
  
)

export default component.exports